import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'GESTION_USER',
  title: 'Wie kann ich Benutzer zu meiner Firma hinzufügen oder entfernen?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Klicken Sie dazu auf die Registerkarte "Einstellungen" und dann auf "Nutzer". Sie finden die Liste der Nutzer, die auf dieser Firma anwesend sind. Alle Benutzer des Organisations können diese Liste und die verschiedenen Rollen sehen. Das Hinzufügen und Löschen von Benutzern kann jedoch nur der Account Manager verwalten.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'So fügen Sie einen Nutzer zu Ihrer Firma hinzu'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Gehen Sie in die Einstellungen Ihrer Firma und dann auf die Registerkarte "Nutzer".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_GESTION_USER/DE_GESTION_USER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Prüfen Sie, ob Sie noch Guthaben haben und klicken Sie dann auf "Nutzer einladen".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_GESTION_USER/DE_GESTION_USER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Geben Sie die E-Mail-Adresse, den Namen, den Vornamen und die Telefonnummer ein'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_GESTION_USER/DE_GESTION_USER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Dann bestätigen Sie'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_GESTION_USER/DE_GESTION_USER_4.png`
  }]
};
